import { lampHeads, lamps, setWaterMode } from './city';
import { bloom, composer, grade, gtao, renderer, scene, smaa, sun } from './scene';
import { S } from './state';

export function applyQuality(q){
  S.quality = q; const hi = q!=='low', ultra = q==='ultra';
  renderer.shadowMap.enabled = hi; sun.castShadow = hi; bloom.enabled = hi; smaa.enabled = hi; gtao.enabled = ultra;
  sun.shadow.mapSize.set(ultra?4096:2048, ultra?4096:2048); if (sun.shadow.map){ sun.shadow.map.dispose(); sun.shadow.map = null; }
  renderer.setPixelRatio(hi ? Math.min(devicePixelRatio, ultra?2:1.5) : 1);
  renderer.setSize(innerWidth, innerHeight); composer.setSize(innerWidth, innerHeight);
  smaa.setSize(innerWidth*renderer.getPixelRatio(), innerHeight*renderer.getPixelRatio());
  grade.uniforms.grain.value = hi ? 0.035 : 0.015;
  const photo = S.world === 'photo'; if (lamps) lamps.visible = hi && !photo; if (lampHeads) lampHeads.visible = hi && !photo;
  setWaterMode(ultra);
  scene.traverse((o: any) => { if (o.material) o.material.needsUpdate = true; });
}
